/**
 * This file contains polyfills for CSSStyleSheet
 */
export async function ensureConstructableStylesheetsSupport() {
  if (
    typeof CSSStyleSheet === 'undefined' ||
    !CSSStyleSheet.prototype.replace
  ) {
    // Dynamically import the polyfill only if needed
    await import('construct-style-sheets-polyfill')
  }
}
